import {
  combineReducers,
  configureStore,
  PreloadedState,
  StateFromReducersMapObject,
} from '@reduxjs/toolkit';
import { authSlice } from './services/auth';
import { rootApi, rootMiddleware } from './api';
import { modalSlice } from './slices/modal.slice';
import { triptychSlice } from './slices/triptych.slice';
import { toasterSlice } from './slices/toaster.slice';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import { appSlice } from './slices/app.slice';

declare const module: any;

const reducer = {
  [rootApi.reducerPath]: rootApi.reducer,
  [authSlice.name]: authSlice.reducer,
  [modalSlice.name]: modalSlice.reducer,
  [triptychSlice.name]: triptychSlice.reducer,
  [toasterSlice.name]: toasterSlice.reducer,
  [appSlice.name]: appSlice.reducer,
};

const reducerCombined = combineReducers(reducer);

const rootReducer = (state, action) => {
  if (action.type === authSlice.actions.logout.type) {
    return reducerCombined(undefined, action);
  }

  return reducerCombined(state, action);
};

export type RootState = StateFromReducersMapObject<typeof reducer>;

export function configureAppStore(preloadedState?: PreloadedState<RootState>) {
  const store = configureStore({
    reducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat([rootApi.middleware, rootMiddleware.middleware]),
  });

  if (module.hot) {
    module.hot.accept(() => {
      store.replaceReducer(rootReducer);
    });
  }

  setupListeners(store.dispatch);

  return store;
}

type Store = ReturnType<typeof configureAppStore>;
export type AppDispatch = Store['dispatch'];
